import filter from 'lodash.filter';

export const getLinksCount = (links, linkActiveTab, value) =>
	links.length > 0 && linkActiveTab !== value ? ` (${links.length})` : null;

export const getLinks = (links, type) =>
	filter(links, {
		type: type
	});
